import type { Participant } from '@lbc/shared';

export interface DailyStanding {
  participant: Participant;
  count: number;
  estimatedPermille: number;
  rank: number | null;
}

export type CrownRank = 1 | 2 | 3;

export function isCrownRank(rank: number | null): rank is CrownRank {
  return rank === 1 || rank === 2 || rank === 3;
}

export function createDailyStandings(
  participants: Participant[],
  participantAlcoholPeaks: ReadonlyMap<string, number>,
  participantCounts: ReadonlyMap<string, number>,
): DailyStanding[] {
  const sorted = participants
    .map((participant) => {
      const estimatedPermille = participantAlcoholPeaks.get(participant.id) ?? 0;
      return {
        participant,
        count: participantCounts.get(participant.id) ?? 0,
        estimatedPermille:
          Number.isFinite(estimatedPermille) && estimatedPermille > 0 ? estimatedPermille : 0,
      };
    })
    .sort(
      (left, right) =>
        right.estimatedPermille - left.estimatedPermille ||
        left.participant.displayName.localeCompare(right.participant.displayName, 'de', {
          sensitivity: 'base',
        }) ||
        left.participant.id.localeCompare(right.participant.id),
    );

  return sorted.map(({ participant, count, estimatedPermille }, index) => {
    if (estimatedPermille <= 0) {
      return { participant, count, estimatedPermille, rank: null };
    }

    return { participant, count, estimatedPermille, rank: index + 1 };
  });
}
